export const ERROR_VALIDATION_LIMIT =
  'Dataset to validate has too many errors, please address them before trying again';

export const ERROR_NOT_FOUND = 'Request failed with status code 404';
